import { Outlet } from "react-router-dom";
import { Header } from "./Header/Header";
import { Footer } from "./footer/footer";

export const FullLayout = () => (
  <>
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

export default FullLayout;
